import api from '@/api'

export default {
  namespaced: true,
  state: {
    total: 0,
    items: [],
    fetching: false,
    lastFetchOptions: null,
    tags: []
  },
  actions: {
    async fetch ({ state, commit, getters }, { type, identifier, options }) {
      commit('fetching', true)
      const { total, items } = await api.getProductsList(type, identifier, options)

      commit('setFetchData', {
        items, total, options
      })
    },
    async fetchItem ({ state, getters, commit }, { type, identifier, productId }) {
      commit('fetching', true)
      const product = await api.syncProduct(type, identifier, productId)

      commit('updateItem', {
        itemOld: state.items.find(product => product.productId === productId),
        itemNew: product
      })
    },
    async addItem ({ state, getters, commit }, { type, identifier, productId }) {
      commit('fetching', true)
      const product = await api.getProduct(type, identifier, productId)

      commit('addItem', product)
      commit('fetching', false)
    },
    async clearProducts ({ state, commit }) {
      const items = []
      commit('setFetchData', {
        items
      })
    },
    fillTags ({ state, commit }, tags) {
      commit('setTags', tags)
    },
    addTag ({ state, commit }, tag) {
      commit('addTag', tag)
    }
  },
  getters: {
    getByProductId: state => productId => state.items.find(product => product.productId === productId)
  },
  mutations: {
    setFetchData (state, { items, total, options }) {
      state.total = total
      state.items = items
      state.lastFetchOptions = {...options}
      state.fetching = false
    },
    updateItems (state, { items }) {
      state.items = items
      state.total = items.length
    },
    updateItem (state, { itemOld, itemNew }) {
      const index = state.items.indexOf(itemOld)
      if (index >= 0) {
        state.items[index] = {...itemNew}
      }
      state.items = [...state.items]
    },
    fetching (state, fetching) {
      state.fetching = fetching
    },
    addItem (state, item) {
      state.items.push(item)
      state.total = state.items.length
    },
    setTags (state, newTags) {
      state.tags = newTags
    },
    addTag (state, tag) {
      state.tags.push(tag)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js